module.exports = __webpack_public_path__ + "img/Netherlands.ce8ae1d9.png";